import React, {useEffect, useMemo} from 'react'
import Text from '../../../components/text/Text'
import useQueryLeaderKeysAll from '../../../hooks/api/leader/useQueryLeaderKeysAll'
import {ICopyLeaders} from '../../../apis/leader/getLeaderKeysAll'
import TableHeader from '../../../components/table/TableHeader'
import TableLayout from '../../../components/table/TableLayout'
import TableItem from '../../../components/table/TableItem'
import useNavigation from '../../../hooks/useNavigation'
import {useDisplayNumber} from '../../../utils/number'
import Span from '../../../components/text/Span'

interface IProps {
    className?: string
    userId?: string
}

const UserLeaderKeysContainer: React.FC<IProps> = ({className, userId}) => {
    const {data, refetch} = useQueryLeaderKeysAll(userId)
    const {goLeaderDetail} = useNavigation()

    const {renderPercent, floorBalance} = useDisplayNumber()

    const leaderKeysList = useMemo(() => {
        const list: ICopyLeaders[] = []
        data?.data?.map(item => list.push(item))
        list?.sort((a, b) => b?.copier_count - a?.copier_count)
        return list
    }, [data, userId])

    useEffect(() => {
        refetch()
    }, [userId])

    return (
        <div className={`bg-white rounded-[10px] p-[30px] shadow-normal ${className}`}>
            <Text className={'text-h3'}>Copy Leader Info</Text>
            <div className={'mt-[30px]'}>
                <TableHeader className={'grid-cols-5 gap-[15px] sm:hidden'}>
                    <Text>Leader Name</Text>
                    <Text className={'text-center'}>Copier</Text>
                    <Text>Earning</Text>
                    <Text>Expected Pay</Text>
                    <Text>Start At</Text>
                </TableHeader>

                <TableLayout className={'shadow-[none] rounded-none'}>
                    {leaderKeysList?.length === 0 && (
                        <div>
                            <Text className={'text-center'}>No Item</Text>
                        </div>
                    )}
                    {leaderKeysList.map(item => (
                        <>
                            <TableItem
                                key={item?.key_id}
                                onClick={() => goLeaderDetail(item?.key_id)}
                                className={'grid-cols-5 gap-[15px] sm:grid-cols-1'}>
                                <div>
                                    <Text>
                                        <Span className={'hidden sm:inline'}>Leader Name : </Span>
                                        {item?.leader_name}
                                    </Text>
                                </div>
                                <div>
                                    <Span className={'hidden sm:inline'}>Copiers : </Span>
                                    <Text
                                        className={`text-center text-ti2 sm:text-left sm:inline-block ${
                                            item?.copier_count === item?.max_copier && 'text-font_red'
                                        }`}>
                                        <Span
                                            className={`text-ti2 ${
                                                item?.copier_count ? 'text-font_green' : 'text-font03'
                                            } ${item?.copier_count === item?.max_copier && 'text-font_red'}`}>
                                            {item?.copier_count}
                                        </Span>

                                        <Span
                                            className={`text-ti2 ${!item?.copier_count && 'text-font03'} ${
                                                item?.copier_count === item?.max_copier && 'text-font_red'
                                            }`}>
                                            /{item?.max_copier}
                                        </Span>
                                    </Text>
                                </div>
                                <div>
                                    <Text className={`${item?.earn ? 'text-font_green text-ti2' : 'text-font03'}`}>
                                        <Span className={'hidden sm:inline'}>Leader Earning : </Span>
                                        {floorBalance(item?.earn, 1000)}
                                    </Text>
                                </div>
                                <div>
                                    <Span className={'hidden sm:inline'}>Expected Pay : </Span>
                                    <Text
                                        className={`sm:inline-block ${
                                            item?.expected_pay > 0
                                                ? 'text-font_leader text-ti2'
                                                : item?.expected_pay < 0
                                                ? 'text-font_red text-ti2'
                                                : 'text-font03'
                                        }`}>
                                        {floorBalance(item?.expected_pay, 1000)}
                                    </Text>
                                </div>
                                <div>
                                    <Text className={'text-font03'}>
                                        <Span className={'hidden sm:inline'}>Start At : </Span>
                                        {new Date(item?.start_at).toLocaleString()}
                                    </Text>
                                </div>
                            </TableItem>
                        </>
                    ))}
                </TableLayout>
            </div>
        </div>
    )
}

export default UserLeaderKeysContainer
